<template>
  <div class="c-match-process text-center column">
    <div class="jingcai" style="display: none;"></div>
    <div class="process-name" :style="timerDisplay(event)">
      <template v-if="event.rbinfo && checkTimer(event) != ''" > <!---->
        <template v-if="event.sptid==1">
          <template v-if="event.rbinfo.htst == '0'">
            <span class="timeInfo">{{ sportTableLang.table['SPORT_TABLE.LBL_HT'] }}</span>
          </template>
          <template v-else-if="validateRBTimer(event) == '1' || (event.rbinfo.tlsec == -1 && event.rbinfo.htst == '1')">
            <span class="timeInfo">{{ sportTableLang.table['SPORT_TABLE.LBL_1HT'] }}</span>
          </template>
          <template v-else-if="validateRBTimer(event) == '2' || (event.rbinfo.tlsec == -1 && event.rbinfo.htst == '2')">
            <span class="timeInfo">{{ sportTableLang.table['SPORT_TABLE.LBL_2HT'] }}</span>
          </template>
          <template v-else> - </template>
        </template>
        <template v-else-if="event.sptid==2"> 
          <template v-if="event.rbinfo.htst == '1'"><span class="timeInfo">{{ sportTableLang.table['SPORT_TABLE.LBL_Q1'] }}</span></template>
          <template v-else-if="event.rbinfo.htst == '2'"><span class="timeInfo">{{ sportTableLang.table['SPORT_TABLE.LBL_Q2'] }}</span></template>
          <template v-else-if="event.rbinfo.htst == '3'"><span class="timeInfo">{{ sportTableLang.table['SPORT_TABLE.LBL_Q3'] }}</span></template>
          <template v-else-if="event.rbinfo.htst == '4'"><span class="timeInfo">{{ sportTableLang.table['SPORT_TABLE.LBL_Q4'] }}</span></template>
          <template v-else-if="event.rbinfo.htst == '5'"><span class="timeInfo">{{ sportTableLang.table['SPORT_TABLE.LBL_1HT'] }}</span></template>
          <template v-else-if="event.rbinfo.htst == '6'"><span class="rb_timeHT">{{ sportTableLang.table['SPORT_TABLE.LBL_HT'] }}</span></template>
          <template v-else-if="event.rbinfo.htst == '7'"><span class="timeInfo">{{ sportTableLang.table['SPORT_TABLE.LBL_2HT'] }}</span></template>
          <template v-else-if="event.rbinfo.htst == '8'"><span class="timeInfo">{{ sportTableLang.table['SPORT_TABLE.LBL_OT'] }}</span></template>
          <template v-else> - </template>
        </template>
      </template>
      <template v-else-if="event.rbinfo && event.sptid>2">
        <div data-v-45641ae6="" class="time-content column">
          <div data-v-45641ae6="" class="process-name">
            <div data-v-45641ae6="" class="process_name " v-if="event.sptid==3 || event.sptid==12 || event.sptid==21">{{ event.rbinfo.st=='NL'? sportTableLang.table['SPORT_TABLE.LBL_SET_S1'] : sportTableLang.table['SPORT_TABLE.LBL_SET_'+event.rbinfo.st] }}</div>
            <div data-v-45641ae6="" class="process_name " v-else-if="event.sptid==23">{{ event.rbinfo.st=='NL'?sportTableLang.table['SPORT_TABLE.LIVE']:sportTableLang.table['SPORT_TABLE.LBL_INN_'+event.rbinfo.st] }}</div>
            <div data-v-45641ae6="" class="process_name " v-else-if="event.sptid==14">{{ event.rbinfo.st=='NL'?sportTableLang.table['SPORT_TABLE.LIVE']:sportTableLang.table['SPORT_TABLE.LBL_PERIOD_'+event.rbinfo.st] }}</div>
            <div data-v-45641ae6="" class="process_name " v-else-if="event.sptid==20">{{ event.rbinfo.st=='NL'?sportTableLang.table['SPORT_TABLE.LIVE']:sportTableLang.table['SPORT_TABLE.LBL_GAME_'+event.rbinfo.st] }}</div>
            <div data-v-45641ae6="" class="process_name " v-else-if="event.sptid==15">{{ event.rbinfo.st=='NL'?sportTableLang.table['SPORT_TABLE.LIVE']:sportTableLang.table['SPORT_TABLE.LBL_FRAME_'+event.rbinfo.st] }}</div>
            <div data-v-45641ae6="" class="process_name " v-else-if="event.sptid==13">{{ event.rbinfo.st=='NL'?sportTableLang.table['SPORT_TABLE.LIVE']:sportTableLang.table['SPORT_TABLE.LBL_Q_'+event.rbinfo.st] }}</div>
            <div data-v-45641ae6="" class="process_name " v-else-if="event.sptid==19">
              <template v-if="event.rbinfo.st=='NL'">
                  {{ sportTableLang.table['SPORT_TABLE.LIVE'] }}
              </template>
              <template v-else-if="event.rbinfo.st=='H1'">
                  {{ sportAllBetLang['ALL_BET.LBL_1HT'] }}
              </template>
              <template v-else-if="event.rbinfo.st=='H2'">
                  {{ sportAllBetLang['ALL_BET.LBL_2HT'] }}
              </template>
            </div>
            <div data-v-45641ae6="" class="process_name " v-else> {{ sportTableLang.table['SPORT_TABLE.LIVE'] }}</div>
          </div>
        </div>
      </template>
    </div>
    <div class="c-match-date text-center date-wrap">
      <template v-if="event.rbinfo && checkTimer(event) != ''">
        <div class="timer-layout relative-position">
          <template v-if="event.sptid==1"> 
            <template v-if="event.rbinfo.htst == '0'">
            </template>
            <template v-else-if="validateRBTimer(event) == '1'">
              <template v-if="event.rbinfo.tlsec">{{ event | rb-timer('mm:ss') }}</template>
              <template v-else>0</template>'</template>
            <template v-else-if="validateRBTimer(event) == '2'">
              <!-- <template v-if="selectedLang == 2 || selectedLang == 3"><br></template> -->
              {{ event | rb-timer('mm:ss') }}
            </template>
            <template v-else> 0 </template>
          </template>
          <template v-else-if="event.sptid==2">
            <template v-if="event.rbinfo.htst == '0'"></template>
            <template v-else>
                <!--template v-if="selectedLang==2 || selectedLang==3"><br></template-->
                <template v-if="event.rbinfo.evetm">{{ event | rb-timer }}</template>

            </template>
          </template>
        </div>
      </template>
      <template v-else-if="!event.rbinfo">
        <template v-if="checkStart(event.dt)==0 && !specialEvent"><span :class="{'timer-layout2':simpleSport==null}" style="min-width: 65px;">{{ sportTableLang.table['SPORT_TABLE.COMMING_SOON'] }}</span></template>
        <template v-else-if="checkStart(event.dt)<60 && !specialEvent"><span :class="{'timer-layout2':simpleSport==null}" style="min-width: 65px;">{{ sportTableLang.table['SPORT_TABLE.START_IN'].replace('{minute}',checkStart(event.dt)) }} </span></template>
        <template v-else>
          <template v-if="selectedLang == 2 || selectedLang == 3">
            <!--span style="min-width: 65px;">{{ moment(matchDateCheck(event.dt)).locale('cn').format("MMM Do") }}<br></span-->
            <span style="min-width: 65px;">{{ matchDateCheck(event.dt) | date('MM月DD日') }}<br></span>
          </template>
          <template v-else>
            <span style="min-width: 65px;">{{ matchDateCheck(event.dt) | date('DD/MM') }}<br></span>
          </template>
          <span>{{ matchDateCheck(event.dt) | date('HH:mm') }}</span>
        </template>
      </template>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import 'moment/locale/zh-cn'
import DateFilter from '@/vue/filters/date'
import allBetMixin from '@/vue/mixins/allBet'

import {
  mapGetters
} from 'vuex'

export default {
  mixins: [allBetMixin],
  props: {
    event: null,
    rowspan: {
      type: String,
      default: '3'
    },
    subMatchKey: null,
  },
  computed: {
    ...mapGetters([
      'sportTableLang',
      'market',
      'selectedMarket',
      'selectedBettype',
      'timeZone',
      'simpleSport',
      'specialEvent',
    ])
  },
  data() {
    return {
      selectedLang: window._langid,
      moment: moment,
    }
  },
  methods: {
    checkStart(end){
      // var startTime = new moment().zone("-04:00").format("YYYY-MM-DD HH:mm:ss");
      var startTime = new moment().utcOffset("-04:00").format("YYYY-MM-DD HH:mm:ss");
      var endTime = moment(end);
      var difference = endTime.diff(moment(startTime), 'minutes')
      if (difference >= 0) {
        return difference;
      }
      return 10000
    },
    timerDisplay(eve){
      var style = 'display: none;'
      if(eve.rbinfo){
        style = ''
      }
      
      return style
    },
    sportListByKey() {
      return _.keyBy(this.$store.getters.sportList, 'sptid')
    },
    checkTodayMatch(event) {
      let status = false;
      var eventDate = new moment(event.dt).format("DD/MM/YYYY")
      // var DateNow = new moment().zone("-04:00").format("DD/MM/YYYY")
      var DateNow = new moment().utcOffset("-04:00").format("DD/MM/YYYY")
      var eventDate = new Date(eventDate);
      var DateNow = new Date(DateNow);

      if (eventDate.valueOf() <= DateNow.valueOf()) {
        status = true;
      }
      return status
    },
    checkTimer(event) {
      return this.$options.filters.checkTimer(event)
    },
    matchDateCheck(date){
      return moment.utc(date).utcOffset(this.$store.getters.timeZone.list[this.$store.getters.timeZone.default][1]).format("YYYY-MM-DD HH:mm:ss")
      },
  },
  destroyed() {
    
  }
}
</script>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/sportTimeColumn.vue